/**
 * The Period Control route table (FSD 1.2.7, F-6.007).
 *
 * Replaces the legacy `/settings/organization/fiscal-periods` screen. The
 * orchestrator spreads `ENTERPRISE_PERIOD_ROUTES` into the router, redirects the
 * old path and adds the nav entry — this packet owns neither shared file.
 *
 * Gated on the read permission; every action is checked on its own authority.
 */

import type { RouteRecordRaw } from 'vue-router'

import { PERIOD_PERMISSIONS } from '@/modules/enterprise/periods/permissions'

export const PERIOD_CONTROL_PATH = '/enterprise/period-control'

export function periodControlRoute(): string {
  return PERIOD_CONTROL_PATH
}

export const ENTERPRISE_PERIOD_ROUTES: RouteRecordRaw[] = [
  {
    path: PERIOD_CONTROL_PATH,
    name: 'enterprise-period-control',
    component: () => import('@/modules/enterprise/periods/PeriodControlView.vue'),
    meta: {
      titleKey: 'enterprise.periods.routeTitles.control',
      permission: PERIOD_PERMISSIONS.read,
    },
  },
]
